<template>
    <v-container grid-list-md fluid class="mt-2">
        <template v-if="isAuthorized">
            <!-- ++ btns export + selects + switch listView row -->
            <v-row no-gutters class="mb-2">
                <!-- <v-col cols="2" class="d-flex justify-center align-center pr-2">
                    <span class="headline" style="white-space: nowrap">Dossier de révision</span>
                </v-col> -->
                <!-- ** export btn -->
                <v-col cols="2" class="d-flex justify-center pr-2" v-if="isAccountingUser">
                    <v-btn-primary
                        block
                        @click="exportDialog = true"
                        :loading="exportLoading"
                        v-if="!stepData || !stepData.stepCount"
                        data-cy="AuditReport-exporter"
                    >
                        Exporter
                    </v-btn-primary>
                </v-col>
                <!-- <v-col cols="2" class="d-flex justify-center pr-2" v-if="isAccountingUser">
                    <v-btn

                        color="secondary"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                        @click="dialogGenerateLiasse = true"
                        data-cy="AuditReport-lPlaquette"
                    >
                        Liasse | Plaquette
                    </v-btn>
                </v-col> -->
                <!-- <v-col cols="3" class="d-flex justify-center">
                    <v-select
                        outlined
                        dense
                        item-color="primary"
                        item-text="name"
                        item-value="id"
                        v-model="accountingReviewLayoutId"
                        :items="candidateAccountingReviewLayouts"
                        hide-details
                        label="Sélectionner un dossier de révision"
                        :full-width="false"
                        class="pr-2"
                    >
                    </v-select>
                </v-col> -->

                <!-- ** status select -->
                <v-col cols="2" class="d-flex justify-center">
                    <v-select
                        outlined
                        :disabled="!auditReport.length"
                        v-model="statusFilter"
                        :items="statusList"
                        hide-details
                        label="Filtrer par statut"
                        :full-width="false"
                        class="pr-2"
                        data-cy="AuditReport-statut"
                        density="compact"
                        item-title="text"
                    >
                    </v-select>
                </v-col>

                <!-- ** cycle select -->
                <v-col cols="2" class="d-flex justify-center">
                    <v-select
                        v-if="listView"
                        v-model="selectedCycleTitle"
                        outlined
                        :disabled="!auditReport || !auditReport.length"
                        item-item-text="cycleTitle"
                        :items="cycles"
                        hide-details
                        label="Filtrer par cycle"
                        :full-width="false"
                        class="pr-2"
                        data-cy="AuditReport-cycle"
                        density="compact"
                        :item-title="(item) => item.cycleTitle"
                    >
                    </v-select>
                </v-col>

                <!-- <v-spacer></v-spacer> -->

                <!-- <v-col cols="1" v-if="accountingPeriod && accountingPeriod.closed" class="px-1 d-flex align-center"> -->
                <!-- // +++++++++++ warning if accountingPeriod.closed -->
                <!-- <h4 v-if="!accountingPeriod" class="yellow_custom--text">
                            Aucune période sélectionnée
                        </h4> -->
                <!-- <h4 class="yellow_custom--text" style="white-space: nowrap">
                            Période clôturée
                        </h4>
                </v-col> -->

                <v-spacer />

                <!-- ** tout superviser -->
                <v-col cols="1" class="d-flex justify-center align-center" v-if="listView">
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                :disabled="isGlobalReviewDisabled"
                                v-bind="props"
                                size="small"
                                icon="$fa-thumbs-up"
                                color="green"
                                @click="updateAllAuditCheckReview()"
                            />
                            <!-- <v-icon
                                :disabled="isGlobalReviewDisabled"
                                v-bind="props"
                                size="small"
                                @click="updateAllAuditCheckReview()"

                                ></v-icon
                            > -->
                        </template>
                        <span>Tout superviser</span>
                    </v-tooltip>
                    <!-- <v-menu offset-y v-if="isAccountingUser">
                        <template v-slot:activator="{ on, props }">
                            <v-btn
                                v-bind="props"
                                v-on="on"
                                icon
                            >
                                <v-icon>$dots_vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                    <v-switch
                                        v-model="showManuals"
                                        dense
                                        inset
                                        :ripple="false"
                                        color="primary"
                                        class="ma-0 pa-0"
                                        hide-details
                                        @click.stop
                                    ></v-switch>
                                <v-list-item-title>Contrôles manuels</v-list-item-title>
                            </v-list-item> -->
                    <!-- <v-list-item
                                @click="showShortComments = !showShortComments"
                            >
                                    <v-switch
                                        v-model="showShortComments"
                                        dense
                                        inset
                                        :ripple="false"
                                        color="primary"
                                        class="ma-0 pa-0"
                                        hide-details
                                        @click.stop
                                    ></v-switch>
                                <v-list-item-title>Commentaires synthétiques</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="showComments = !showComments"
                            >
                                    <v-switch
                                        v-model="showComments"
                                        dense
                                        inset
                                        :ripple="false"
                                        color="primary"
                                        class="ma-0 pa-0"
                                        hide-details
                                        @click.stop
                                    ></v-switch>
                                <v-list-item-title>Synthèses</v-list-item-title>
                            </v-list-item> -->
                    <!-- </v-list>
                    </v-menu> -->
                </v-col>

                <!-- ** listView -->
                <v-col cols="auto" class="d-flex justify-center align-center">
                    <v-switch
                        v-model="listView"
                        label="Synthèse / Comptes + Cycles"
                        hide-details
                        class="pl-2 mt-0"
                        data-cy="AuditReport-liste"
                    />
                </v-col>

                <!-- <v-col cols="2" class="px-2" v-if="isAutonomousUser">
                    <v-btn

                        color="secondary"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                        @click="generateBncLiasse()"
                    >
                        Générer ma 2035
                    </v-btn>
                </v-col> -->
            </v-row>

            <!-- <oss-data-table
                :headers="headers"
                :items="filteredAuditReport"
                :itemLength="30000"
                @load-more="loadMore()"
                :dense="true"
                :striped="true"
                :fixed-header="true"
                checkbox-color="primary"
                :itemKey="'key'"
            >
                <template v-slot:item="{ item, index }">
                    <tr>
                        <template v-if="item.type === 'cycleTitle'">
                            <td :rowspan="cycleTitleRowSpan(index)">
                                {{ item.cycleTitle }}
                            </td>
                        </template>
                        <template v-else>
                            <td>
                                {{ item }}
                            </td>
                        </template>
                    </tr>
                </template>
            </oss-data-table> -->

            <!-- ++ loading -->
            <template v-if="loading">
                <v-card elevation="0" style="background-color: #ffffff; border-radius: 25px">
                    <v-card-title v-if="loading" class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <!-- ++ listView (normal mode) -->
            <template v-else-if="listView">
                <v-row
                    no-gutters
                    v-if="
                        !accountingPeriodId || !filteredAuditReport || !filteredAuditReport.length
                    "
                >
                    <v-col cols="12">
                        <v-card
                            elevation="0"
                            style="background-color: #ffffff; border-radius: 25px"
                        >
                            <v-card-title
                                v-if="!accountingPeriodId"
                                class="pa-4 d-flex justify-center"
                            >
                                Choisissez un exercice comptable
                            </v-card-title>
                            <v-card-title
                                v-else-if="!filteredAuditReport || !filteredAuditReport.length"
                                class="pa-4 d-flex justify-center"
                            >
                                Pas de données pour l'exercice sélectionné
                            </v-card-title>
                        </v-card>
                    </v-col>
                </v-row>
                <v-progress-linear
                    readonly
                    rounded
                    height="20"
                    class="mt-3"
                    v-if="!loading"
                    :model-value="globalStatusPercent"
                    color="primary"
                >
                    <strong>{{ globalStatus }}</strong>
                </v-progress-linear>
                <v-data-table
                    :headers="headers"
                    :items="filteredAuditReport"
                    class="table mt-3"
                    fixed-header
                    height="calc(100vh - 239px)"
                    :items-per-page="-1"
                    v-if="!loading && filteredAuditReport && filteredAuditReport.length"
                >
                    <template v-slot:item="props">
                        <tr v-if="props.item.type === 'cycleTitle'">
                            <td />
                            <td colspan="4">
                                <h2>{{ props.item.title || props.item.cycleTitle }}</h2>
                            </td>
                            <td />
                        </tr>

                        <!-- ** soon availables audits  -->
                        <tr
                            v-else-if="disabledAuditKeys.includes(props.item.key)"
                            style="color: grey"
                        >
                            <td />

                            <td>
                                <h3 v-if="props.item.title" class="pl-3">
                                    {{
                                        props.item.title
                                            ? props.item.title
                                            : $t("audit." + props.item.key + ".title", 1)
                                    }}
                                    - <b>BIENT&#xd4;T DISPONIBLE</b>
                                </h3>
                                <h3 v-else-if="props.item.name">
                                    {{ props.item.name }} - <b>BIENT&#xd4;T DISPONIBLE</b>
                                </h3>
                            </td>

                            <td>
                                <v-progress-linear
                                    readonly
                                    rounded
                                    color="green"
                                    height="7"
                                    disabled
                                >
                                    <!-- <strong>{{ globalStatus }}</strong> -->
                                </v-progress-linear>
                                <!-- {{getAuditProgress(props.item)}} -->
                            </td>

                            <td>
                                <div class="d-flex justify-center">
                                    <v-icon icon="$oss-circle-check" size="small" color="primary" />
                                </div>
                            </td>

                            <td>
                                <div class="d-flex justify-center">
                                    <v-btn-icon
                                        icon="$fa-thumbs-up"
                                        color="green"
                                        size="small"
                                        disabled
                                    />
                                </div>
                            </td>

                            <td />
                        </tr>

                        <!-- ** actives audits -->
                        <tr v-else @click.stop="openAudit(props.item)" style="cursor: pointer">
                            <td />

                            <td>
                                <h3
                                    v-if="props.item.title"
                                    :data-cy="'AuditReport-' + props.item.key"
                                >
                                    {{
                                        props.item.title
                                            ? props.item.title
                                            : $t("audit." + props.item.key + ".title", 1)
                                    }}

                                    <v-icon
                                        v-if="
                                            props.item.action &&
                                            props.item.action.pathName !== 'manual-audit'
                                        "
                                        class="ml-2"
                                        color="ternary"
                                        size="x-small"
                                        >$fa-magic</v-icon
                                    >
                                </h3>

                                <h3 v-else-if="props.item.name">
                                    {{ props.item.name }}
                                </h3>
                            </td>

                            <td>
                                <v-progress-linear
                                    readonly
                                    rounded
                                    color="green"
                                    height="7"
                                    :model-value="getAuditCheckProgress(props.item)"
                                >
                                    <!-- <strong>{{ globalStatus }}</strong> -->
                                </v-progress-linear>
                                <!-- {{getAuditProgress(props.item)}} -->
                            </td>

                            <td>
                                <div class="d-flex justify-center">
                                    <v-icon
                                        :icon="
                                            props.item.status && props.item.status === 'VALIDATED'
                                                ? '$oss-circle-check'
                                                : '$oss-circle-uncheck'
                                        "
                                        size="small"
                                        :color="
                                            props.item.status && props.item.status === 'VALIDATED'
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                    />
                                </div>
                            </td>

                            <td>
                                <div class="d-flex justify-center">
                                    <v-btn-icon
                                        :icon="getAuditReviewIcon(props.item)"
                                        :color="getAuditReviewIconColor(props.item)"
                                        :disabled="
                                            props.item.status !== 'VALIDATED' || !isEnableReview
                                        "
                                        @click.stop="updateAuditCheckReview(props.item)"
                                        size="small"
                                    >
                                    </v-btn-icon>
                                </div>
                            </td>

                            <td>
                                <div class="d-flex justify-center">
                                    <v-btn-icon
                                        icon="$oss-activity"
                                        color="primary"
                                        @click.stop="
                                            displayActivityDialog = true;
                                            displayAuditCheckActivityKey = props.item.key;
                                        "
                                    />
                                </div>
                            </td>

                            <td />
                        </tr>
                    </template>
                </v-data-table>

                <!-- <v-row v-for="(item, i) of filteredAuditReport" :key="`i${i}`">
                    <v-col>
                        <h2 v-if="item.type === 'cycleTitle'" class="pb-2">
                            {{item.title ? item.title : item.cycleTitle}}
                        </h2>
                        <v-card elevation="0" class="my-2" style="background-color: #FFFFFF; border-radius: 25px;" v-else>
                            <v-card-title class="px-4">
                                <v-row>
                                    <v-col cols="auto" class="d-flex align-center" >
                                        <h3 v-if="item.type !== 'cycleTitle'">
                                            {{ item.title ? item.title : $t('audit.' + item.key + '.title', 1) }}
                                        </h3>

                                        <h3 v-else-if="item.name">
                                            {{ item.name }}
                                        </h3>
                                    </v-col>

                                    <v-spacer></v-spacer>
                                    <v-col cols="1" class="mr-2">
                                        <v-btn
                                            rounded="circle" size="small" class="back_btn"
                                            @click.stop="item.pathName ? openControl(item) : openAction(item)"
                                            :data-cy="'auditStatus-action-'+item.key"
                                        >
                                            <v-icon>$spellcheck</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-title>

                            <v-card-text v-if="item.pathName === 'manual-audit' && !isAutonomousUser"  class="pt-0 pb-4">
                                <p style="color: blue" class="py-0 mb-0">
                                    Contrôle manuel
                                </p>
                            </v-card-text>

                            <v-card-text v-if="item.shortComment && item.shortComment !== 'Aucun commentaire' && showShortComments" class="px-4 pb-4">
                                <h2 class="pb-4">Commentaire synthétique</h2>
                                <p v-if="!item.shortComment.includes('\n')" class="mb-0">
                                    {{item.shortComment}}
                                </p>

                                <template v-else>
                                    <div v-for="(line, index) in toArray(item.shortComment)" :key="index">
                                        <p>{{line}}</p>
                                    </div>
                                </template>

                            </v-card-text>

                            <v-card-text v-if="item.comments && item.comments[0] && item.comments[0].data && showComments" class="px-4 pb-4">
                                <h2 class="pb-4">Synthèse</h2>

                                <div v-for="(line, index) in item.comments[0].data" :key="index">
                                    <v-divider v-if="index || item.auditCheck" class="mb-2"></v-divider>
                                    <h3 v-if="line.title" class="mb-2">{{line.title}}</h3>

                                    <div v-if="line.texts">
                                        <div v-for="(text, ii) in line.texts" :key="ii" class="pb-4">
                                            <v-row v-if="text.subtitle || text.comment">
                                                <v-col cols="auto" class="px-2 pt-1">
                                                    <v-icon v-if="text.validated" icon="$check_circle" size="large" />

                                                    <v-icon left size="small"  v-else-if="text.validated === false" color="primary" class="mt-2" icon="$check_circle" />

                                                    <v-icon left size="small"  v-else color="white" class="mt-2" icon="$check_circle" />
                                                </v-col>

                                                <v-col>
                                                    <p v-if="text.subtitle" class="mb-0">
                                                        <b v-if="text.subtitle && text.subtitle.length">
                                                            {{text.subtitle}}
                                                        </b>
                                                    </p>

                                                    <div v-if="text.comment" class="mb-0">
                                                        <div v-for="(commentLine, ic) in toArray(text.comment)" :key="ic" class="mb-0">
                                                            <p class="mb-0">
                                                                {{commentLine}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </v-col>
                                            </v-row>

                                            <v-data-table
                                                v-if="text.table && Object.keys(text.table).length"
                                                :headers="text.table.headers"
                                                :items="text.table.items"
                                                multi-sort
                                                :loading="loading"
                                                class="table"
                                                style="border: 1px #EDEDED solid;"
                                            >
                                            </v-data-table>
                                        </div>
                                    </div>

                                    <p v-if="line.remainingToValidate && !line.remainingToValidate.startsWith('0/0')" class="pt-0 pb-4">
                                        <b>{{line.remainingToValidate}}</b>
                                    </p>

                                    <p v-if="!line.title && (!line.texts || !line.texts.length) && (!line.remainingToValidate || line.remainingToValidate.startsWith('0/0'))" class="pb-4">
                                        <b>Ce contrôle n'a pas encore été analysé</b>
                                    </p>

                                    <p v-if="line.title && (!line.texts || !line.texts.length) && !line.remainingToValidate" class="pb-4">
                                        <b>Ce contrôle n'a pas encore de bouton "Valider"</b>
                                    </p>
                                </div>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row> -->
            </template>

            <!-- ++ cycle accountable accounts generalLedger mode (Vincent) -->
            <template v-else>
                <!-- ** first row : tabs -->
                <v-row no-gutters>
                    <!-- <v-col cols="3"> -->
                    <v-tabs
                        v-model="selectedCycleTab"
                        class="d-flex justify-center"
                        style="border-radius: 16px"
                        center-active
                    >
                        <v-tab :model-value="-1"> Balance </v-tab>
                        <v-tab
                            v-for="cycle of tabCycles"
                            :key="cycle.cycleTitle"
                            class="d-flex justify-space-between"
                            :model-value="cycle"
                            >{{ cycle.cycleTitle }}</v-tab
                        >
                    </v-tabs>
                </v-row>

                <!-- ** full body -->
                <v-row no-gutters>
                    <!-- <v-col cols="12"> -->
                    <v-window style="width: 100%" class="mt-1" v-model="selectedCycleTab">
                        <v-window-item style="width: 100%">
                            <v-row no-gutters>
                                <!-- ** hover - vertical : first cycles column/s -->
                                <v-hover v-slot:default="{ isHovering, props }">
                                    <!-- ** responsive first cycle titles column -->
                                    <v-col :cols="isHovering ? 3 : 1" v-bind="props">
                                        <v-list
                                            v-bind="props"
                                            style="border-radius: 16px; height: 72vh"
                                            class="mt-3"
                                        >
                                            <v-list-item
                                                v-for="cycle in tabCycles"
                                                :key="cycle.index"
                                                class="d-flex align-center"
                                                @click="selectedCycleGLTab = cycle"
                                                :model-value="cycle"
                                            >
                                                <!-- ** tooltip if title.length > 35 -->
                                                <v-tooltip
                                                    v-if="cycle.cycleTitle.length > 35"
                                                    location="top"
                                                >
                                                    <template v-slot:activator="{ props }">
                                                        <p
                                                            v-bind="props"
                                                            :class="
                                                                cycle.index ===
                                                                selectedCycleGLTab.index
                                                                    ? 'text-primary'
                                                                    : ''
                                                            "
                                                            style="text-transform: uppercase"
                                                        >
                                                            {{
                                                                getDisplayedTitle(
                                                                    cycle.cycleTitle,
                                                                    isHovering,
                                                                )
                                                            }}
                                                        </p>
                                                    </template>

                                                    <span style="text-transform: uppercase">{{
                                                        cycle.cycleTitle
                                                    }}</span>
                                                </v-tooltip>

                                                <!-- ** no tooltip if shorter -->
                                                <p
                                                    v-else
                                                    style="text-transform: uppercase"
                                                    :class="
                                                        cycle.index === selectedCycleGLTab.index
                                                            ? 'text-primary'
                                                            : ''
                                                    "
                                                >
                                                    {{
                                                        getDisplayedTitle(
                                                            cycle.cycleTitle.toUpperCase(),
                                                            isHovering,
                                                        )
                                                    }}
                                                </p>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>

                                    <!-- ** general ledger -->
                                    <!-- ** responsive second column -->
                                    <v-col
                                        :cols="isHovering ? 9 : 11"
                                        style="height: calc(100vh - 200px)"
                                    >
                                        <v-card
                                            elevation="0"
                                            style="background-color: #ffffff; border-radius: 16px"
                                            class="ml-3 mt-3"
                                        >
                                            <v-card-title class="d-flex justify-start py-2">
                                                Racines des comptes concernées par le cycle :
                                                {{ templateAccountableAccountRoots }}
                                            </v-card-title>

                                            <v-card-title
                                                v-if="templateExcludedAccountableAccountRoots"
                                                class="d-flex justify-start pt-0 pb-2"
                                            >
                                                Racines des comptes exclus :
                                                {{ templateExcludedAccountableAccountRoots }}
                                            </v-card-title>
                                        </v-card>

                                        <GeneralLedger
                                            ref="generalLedger"
                                            :companyId="companyId"
                                            :accountingPeriodId="accountingPeriodId"
                                            :accountableAccountFilter="
                                                selectedCycleGLTab.accountableAccountsRoot
                                            "
                                            :excludedAccountableAccountFilter="
                                                selectedCycleGLTab.excludedAccountableAccountsRoot ||
                                                []
                                            "
                                            :hideOptions="true"
                                            :inThirdParty="false"
                                            :enableAuditedAccountableAccounts="true"
                                            :tableHeight="'65vh'"
                                            :hideBodyAppend="true"
                                            :inNm1="true"
                                        >
                                        </GeneralLedger>
                                    </v-col>
                                </v-hover>
                            </v-row>
                        </v-window-item>
                        <v-window-item
                            style="width: 100%"
                            v-for="cycle of tabCycles"
                            :key="cycle.indexStart"
                        >
                            <!-- <v-row no-gutters> -->
                            <v-data-table
                                :headers="headers"
                                :items="cycleTableItems"
                                class="table mt-3"
                                fixed-header
                                height="calc(100vh - 275px)"
                                :items-per-page="-1"
                                v-if="!loading"
                            >
                                <template v-slot:item="props">
                                    <!-- ** cycleTitle -->
                                    <tr v-if="props.item.type === 'cycleTitle'">
                                        <td />

                                        <td colspan="4">
                                            <h2>{{ props.item.title || props.item.cycleTitle }}</h2>
                                        </td>
                                        <td />
                                    </tr>

                                    <!-- ** disabled controls - soon availables Vincent -->
                                    <tr
                                        v-else-if="disabledAuditKeys.includes(props.item.key)"
                                        style="color: grey; cursor: pointer"
                                    >
                                        <td />

                                        <!-- ** title -->
                                        <td>
                                            <h3 v-if="props.item.title" class="pl-3">
                                                {{
                                                    props.item.title
                                                        ? props.item.title
                                                        : $t(
                                                              "audit." + props.item.key + ".title",
                                                              1,
                                                          )
                                                }}
                                                - <b>BIENT&#xd4;T DISPONIBLE</b>
                                            </h3>
                                            <h3 v-else-if="props.item.name">
                                                {{ props.item.name }} -
                                                <b>BIENT&#xd4;T DISPONIBLE</b>
                                            </h3>
                                        </td>

                                        <!-- ** progress-linear -->
                                        <td>
                                            <v-progress-linear
                                                readonly
                                                rounded
                                                color="green"
                                                height="7"
                                                disabled
                                            >
                                                <!-- <strong>{{ globalStatus }}</strong> -->
                                            </v-progress-linear>
                                            <!-- {{getAuditProgress(props.item)}} -->
                                        </td>

                                        <td>
                                            <div class="d-flex justify-center">
                                                <v-icon
                                                    icon="$oss-circle-check"
                                                    size="small"
                                                    color="primary"
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div class="d-flex justify-center">
                                                <v-btn-icon
                                                    icon="$fa-thumbs-up"
                                                    color="green"
                                                    size="small"
                                                    disabled
                                                />
                                            </div>
                                        </td>

                                        <td />
                                    </tr>

                                    <!-- ** audits Vincent -->
                                    <tr
                                        v-else
                                        @click.stop="openAudit(props.item)"
                                        style="cursor: pointer"
                                    >
                                        <td />

                                        <!-- ** title -->
                                        <td>
                                            <h3 v-if="props.item.title" class="pl-3">
                                                {{
                                                    props.item.title
                                                        ? props.item.title
                                                        : $t(
                                                              "audit." + props.item.key + ".title",
                                                              1,
                                                          )
                                                }}
                                            </h3>
                                            <h3 v-else-if="props.item.name">
                                                {{ props.item.name }}
                                            </h3>
                                        </td>

                                        <!-- ** progress-linear -->
                                        <td>
                                            <v-progress-linear
                                                readonly
                                                rounded
                                                color="secondary"
                                                height="7"
                                                :model-value="getAuditCheckProgress(props.item)"
                                            >
                                                <!-- <strong>{{ globalStatus }}</strong> -->
                                            </v-progress-linear>
                                            <!-- {{getAuditProgress(props.item)}} -->
                                        </td>

                                        <td>
                                            <div class="d-flex justify-center">
                                                <v-icon
                                                    :icon="
                                                        props.item.status &&
                                                        props.item.status === 'VALIDATED'
                                                            ? '$oss-circle-check'
                                                            : '$oss-circle-uncheck'
                                                    "
                                                    size="small"
                                                    :color="
                                                        props.item.status &&
                                                        props.item.status === 'VALIDATED'
                                                            ? 'primary'
                                                            : 'secondary'
                                                    "
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div class="d-flex justify-center">
                                                <v-btn-icon
                                                    :icon="getAuditReviewIcon(props.item)"
                                                    :color="getAuditReviewIconColor(props.item)"
                                                    :disabled="
                                                        props.item.status !== 'VALIDATED' ||
                                                        !isEnableReview
                                                    "
                                                    @click.stop="updateAuditCheckReview(props.item)"
                                                    size="small"
                                                />
                                            </div>
                                        </td>

                                        <td>
                                            <div class="d-flex justify-center">
                                                <v-btn-icon
                                                    icon="$oss-activity"
                                                    color="primary"
                                                    @click.stop="
                                                        displayActivityDialog = true;
                                                        displayAuditCheckActivityKey =
                                                            props.item.key;
                                                    "
                                                />
                                            </div>
                                        </td>

                                        <td />
                                    </tr>
                                </template>
                            </v-data-table>
                            <!-- </v-row> -->
                        </v-window-item>
                    </v-window>
                    <!-- </v-col> -->
                </v-row>
            </template>

            <oss-dialog
                v-if="dialogGenerateLiasse"
                v-model="dialogGenerateLiasse"
                title="Synthèse pour la génération de la liasse"
                :previous-display="generateLiasseStep !== 0"
                :valid-disabled="!signer"
                @valid="generateTaxReturn()"
                @previous="generateLiasseStep = 0"
                @close="generateLiasseStep = 0"
                min-width="60vw"
            >
                <v-window v-model="generateLiasseStep">
                    <v-window-item :key="0">
                        <v-row no-gutters class="pt-2">
                            <v-col cols="4" class="px-1">
                                <v-text-field-filled
                                    readonly
                                    label="Signataire"
                                    @click="generateLiasseStep = 1"
                                    outlined
                                    hide-details
                                    :model-value="
                                        signer
                                            ? `${signer.firstname || ''} ${signer.lastname || ''}`
                                            : ''
                                    "
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="4" class="px-1">
                                <v-text-field-filled
                                    v-model="options.signer.quality"
                                    label="Qualité"
                                    outlined
                                    hide-details
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-text-field-filled
                                    v-model="options.signer.city"
                                    label="Lieu"
                                    outlined
                                    hide-details
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-divider class="my-2" />
                            </v-col>
                            <v-col cols="4" class="px-1">
                                <v-text-field-filled
                                    readonly
                                    label="Société"
                                    outlined
                                    hide-details
                                    :model-value="company.displayName || company.name"
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="6" class="px-1">
                                <v-text-field-filled
                                    readonly
                                    label="Période comptable"
                                    outlined
                                    hide-details
                                    :model-value="`${formatDate(
                                        accountingPeriod.start,
                                    )} - ${formatDate(accountingPeriod.end)}`"
                                    density="compact"
                                />
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <v-window-item :key="1">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <select-user
                                    class="px-1"
                                    v-model="signer"
                                    :companyId="userCompanyId"
                                    :type="'NATURAL_PERSON'"
                                    :withEmail="true"
                                />
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </oss-dialog>

            <oss-dialog
                v-if="exportDialog"
                v-model="exportDialog"
                title="Exporter l'extrait"
                @close="resetExportDialog()"
                @previous="exportWindowStep = 0"
                :previous-display="exportWindowStep > 0"
                :valid-title="exportWindowStep === 2 ? 'Valider' : 'Suivant'"
                :hide-valid="exportWindowStep !== 0"
                @valid="nextStepExportDialog()"
                prefixDataCy="AuditReport-valid"
                min-width="800px"
            >
                <v-window v-model="exportWindowStep">
                    <!-- // ** 3 checkboxes - short - long - annexes -->
                    <v-window-item :key="0">
                        <!-- // ** Commentaires synthétiques -->
                        <v-checkbox
                            class="pb-1 ma-0"
                            hide-details
                            dense
                            v-model="exportShortComment"
                            label="Commentaires synthétiques"
                        />
                        <!-- // ** Commentaires détaillés -->
                        <v-checkbox
                            class="pb-1 ma-0"
                            hide-details
                            dense
                            v-model="exportFullComment"
                            label="Commentaires détaillés"
                        />
                        <!-- // ** Annexes -->
                        <v-checkbox
                            class="pb-1 ma-0"
                            hide-details
                            dense
                            v-model="exportAnnexes"
                            label="Annexes"
                        />
                    </v-window-item>

                    <!-- // ** docType choice - DOCX OK - PDF TODO - XLS NOT TODO -->
                    <v-window-item :key="1">
                        <v-list subheader lines="two">
                            <v-list-item
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item rounded-lg'
                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                "
                                @click="exportFile('DOCX')"
                                data-cy="AuditReport-docs"
                            >
                                <template #prepend>
                                    <v-icon color="secondary">$fa-file-word </v-icon>
                                </template>

                                <v-list-item-title>Docx</v-list-item-title>

                                <template #append>
                                    <v-btn-next />
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item rounded-lg'
                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                "
                                @click="exportFile('PDF')"
                                data-cy="AuditReport-PDF"
                            >
                                <template #prepend>
                                    <v-icon color="secondary"> $fa-file-pdf </v-icon>
                                </template>

                                <v-list-item-title>Pdf</v-list-item-title>

                                <template #append>
                                    <v-btn-next />
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-window-item>

                    <!-- // ** progressBar -->
                    <!-- <v-window-item :key="2">
                                {{ accountingItemExport ? accountingItemExport.name : "" }}

                                <v-row no-gutters v-if="accountingItemExport">
                                    <v-col cols="10" class="d-flex align-center">
                                        <v-progress-linear
                                            color="secondary"
                                            height="10"
                                            rounded
                                            buffer-value="0"
                                            :value="100 * accountingItemExport.step / accountingItemExport.stepCount"
                                            stream
                                        ></v-progress-linear>
                                    </v-col>
                                    <v-col cols="2" class="d-flex align-center justify-center">
                                        <v-btn
                                            icon
                                            color="secondary"
                                            :disabled="!accountingItemExport.file"
                                            @click.stop="directDownload()"
                                        >
                                            <v-icon  size="small">$fa-cloud-download-alt</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-window-item> -->
                </v-window>
            </oss-dialog>
            <oss-dialog
                v-if="displayActivityDialog"
                v-model="displayActivityDialog"
                title="Activité"
                valid-title="Fermer"
                @valid="displayActivityDialog = false"
                @close="
                    displayActivityDialog = false;
                    displayAuditCheckActivityKey = null;
                "
                min-width="60vw"
            >
                <UsersActivitiesHistory
                    :auditCheckKey="displayAuditCheckActivityKey"
                    :accountingPeriodId="accountingPeriodId"
                >
                </UsersActivitiesHistory>
            </oss-dialog>
        </template>
        <!-- </template> -->
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";
import { cloneDeep } from "lodash";

import { State2Way } from "@/decorators";

import { UserActivity } from "../../services/userActivityServices";

import SingleDataCard from "../../components/cards/SingleDataCard.vue";
import ReconciliationFullClient from "../ReconciliationFullClient.vue";
import SelectUser from "../user/SelectUser.vue";
import OssDataTable from "../ossComponents/ossDataTable2.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import GeneralLedger from "../GeneralLedger2.vue";

import AUDIT_REPORT from "../../graphql/audit/AuditReport.gql";
import AUDIT_REPORT_TO_DOCX from "../../graphql/audit/AuditReportToDocx.gql";
import GENERATE_TAX_RETURN from "../../graphql/GenerateTaxReturn.gql";
import CANDIDATE_ACCOUNTING_REVIEW_LAYOUTS from "../../graphql/audit/CandidateAccountingReviewLayouts.gql";
import UPDATE_AUDIT_CHECK_RESULTS from "../../graphql/audit/UpdateAuditCheckResults.gql";

import DECLARATIONS_LIST from "../../graphql/declarationForm/DeclarationsFormList.gql";

import getEnv from "../../env";
import { NotificationBase } from "../NotificationBase";

import { disabledAuditKeys } from "../../../../backend/src/common/audit/auditFunctions";
import { checkAccessRights } from "../../services/accessRightServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

const env = getEnv();

const dicoTitles = {
    mission: "Mission",
    bank: "Trésorerie / Financement : Banque",
    vmp: "Trésorerie / Financement : VMP",
    emprunts: "Trésorerie / Financement : Emprunts",
    cash: "Trésorerie / Financement : Caisse",
    associates: "Trésorerie / Financement : Groupe et associés",
    suppliers: "Achats - fournisseurs",
    externalCharges: "Charges externes",
    customers: "Ventes - clients",
    stocks: "Stocks et encours",
    fixedAssets: "Immobilisations",
    staff: "Personnel",
    TNS: "TNS - Travailleurs Non Salariés",
    VAT: "Etat - TVA",
    taxes: "Etat - Autres impôts et taxes",
    capitals: "Capitaux",
    others: "Autres comptes",
    taxableIncome: "Résultat fiscal",
    specificAnnexes: "Annexes spécifiques",
};

@Component({
    components: {
        SingleDataCard,
        ReconciliationFullClient,
        SelectUser,
        OssDataTable,
        UsersActivitiesHistory,
        GeneralLedger,
    },
})
export class AuditReport extends NotificationBase {
    listView: boolean = true;

    selectedCycleTab = null;

    selectedCycleGLTab = null;

    wizardStep = "1";

    bankTransactionId = "";

    generateLiasseStep = 0;

    showManuals = true;

    selectedCycleTitle = "Tous";

    statusFilter = "all";

    showShortComments = true;

    showComments = true;

    exportDialog = false;
    exportWindowStep = 0;
    exportShortComment = true;
    exportFullComment = true;
    exportAnnexes = false;
    // type = "DOCX"

    dialogGenerateLiasse = false;

    // activity: any;

    displayActivityDialog: boolean = false;

    displayAuditCheckActivityKey: string = null;

    isHover: boolean = false;

    get tabsAndBalanceCols() {
        if (this.isHover) {
            return {
                tabs: 3,
                balance: 9,
            };
        }
        return {
            tabs: 1,
            balance: 11,
        };
    }

    get cycleTableItems() {
        let items = [];
        if (this.selectedCycleTab) {
            items = this.auditReport.slice(
                this.cycles[this.selectedCycleTab].indexStart,
                this.cycles[this.selectedCycleTab].indexEnd + 1,
            );
            if (items.length) {
                items = this.commonFilters(items);
            }
        }
        return items;
    }

    get accountableAccountsRoot() {
        let aas = [];
        if (!this.selectedCycleGLTab) {
            aas = this.tabCycles?.[0]?.accountableAccountsRoot || [];
        } else {
            aas = this.tabCycles?.[this.selectedCycleGLTab]?.accountableAccountsRoot || [];
        }
        return aas;
    }

    get excludedAccountableAccountsRoot() {
        let excludedAas = [];
        if (!this.selectedCycleGLTab) {
            excludedAas = this.tabCycles?.[0]?.excludedAccountableAccountsRoot || [];
        } else {
            excludedAas =
                this.tabCycles?.[this.selectedCycleGLTab]?.excludedAccountableAccountsRoot || [];
        }
        return excludedAas;
    }

    @State2Way("updateAuditReportAccountingReviewLayoutId", "auditReport.accountingReviewLayoutId")
    accountingReviewLayoutId: string;

    @State2Way(
        "updateAuditReportPreviousNextFilteredAccountingReviewLayout",
        "auditReport.previousNextFilteredControls",
    )
    previousNextFilteredControls: Array<any>;

    @Watch("companyId")
    onCompanyIdChange() {
        this.accountingReviewLayoutId = "";
    }

    @Watch("listView")
    onListViewChange() {
        if (this.auditReport.length) {
            this.calculateCycles();
        }
    }

    get headers() {
        const headers = [
            { title: "", value: null, sortable: false, width: "5%" },
            { title: "Titre", value: "title", align: "left", sortable: false, width: "60%" },
            {
                title: "Avancement",
                value: "progress",
                align: "center",
                sortable: false,
                width: "10%",
            },
            { title: "Statut", value: "status", align: "center", sortable: false, width: "10%" },
            {
                title: "Supervision",
                value: "reviewed",
                align: "center",
                sortable: false,
                width: "10%",
            },
            {
                title: "Activité",
                value: "activity",
                align: "center",
                sortable: false,
                width: "10%",
            },
            { title: "", value: null, sortable: false, width: "5%" },
        ];
        return headers;
    }

    get signer() {
        return this.options.signer.user;
    }

    set signer(value) {
        this.options.signer.user = value;
        this.generateLiasseStep = 0;
    }

    get loading() {
        if (this.$apollo.queries.auditReport) {
            return this.$apollo.queries.auditReport.loading;
        }
        return false;
    }

    options = {
        signer: {
            quality: "Expert Comptable",
            user: null,
            city: "",
        },
    };

    get companyId() {
        return this.$store?.state?.selected_company?.id || "";
    }

    get company() {
        return this.$store?.state?.selected_company || {};
    }

    get currentUser(): User {
        return this.$store?.state?.user;
    }

    get isAuthorized() {
        // const authorized = checkAccessRights(this.currentUser, 'auditReport', 'read') // New version
        const authorized = checkAccessRights(this.currentUser, "accounting", "auditReport"); // Old version
        return authorized;
    }

    get isEnableReview() {
        return checkAccessRights(this.currentUser, "auditReport", "enableReview");
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser || false;
    }

    get userCompanyId() {
        return this.currentUser?.company?.id || "";
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser || false;
    }

    get accountingPeriodId() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod
            ? this.$store.state.accountingPeriod.selectedAccountingPeriod.id
            : "";
    }

    get accountingPeriod() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod
            ? this.$store.state.accountingPeriod.selectedAccountingPeriod
            : null;
    }

    get accountingFirmId() {
        if (this.currentUser.company.accountingFirm) {
            return this.currentUser.company.id;
        }
        return undefined;
    }

    get isGlobalReviewDisabled() {
        if (!this.auditReport.length || !this.isEnableReview) {
            return true;
        } else {
            for (const ac of this.auditReport) {
                if (ac.status && ac.status === "VALIDATED") {
                    return false;
                }
            }
        }
        return true;
    }

    get statusList() {
        return [
            {
                text: "Tous",
                value: "all",
            },
            {
                text: "A valider",
                value: "toValidate",
            },
            {
                text: "Validés",
                value: "validated",
            },
            {
                text: "A superviser",
                value: "toReview",
            },
            {
                text: "Supervisés",
                value: "reviewed",
            },
            {
                text: "Refusés",
                value: "rejected",
            },
        ];
    }

    get disabledAuditKeys() {
        return disabledAuditKeys;
    }

    // get headers() {
    //     return [
    //         {
    //             text: "Type",
    //             value: "type",
    //             sortable: true,
    //             align: "start"
    //         },
    //         {
    //             text: "Nom",
    //             value: "title",
    //             sortable: true,
    //             align: "start"
    //         }
    //     ]
    // }

    // initializeUserActivity() {
    //     this.activity = new UserActivity("CREATE", "AUDIT_CHECK_RESULT", moment());
    // }

    beforeMount() {
        this.addListener("accountingItemExport");
        // this.initializeUserActivity();
        if (this.auditReport?.length) {
            this.calculateCycles();
        }
    }

    beforeDestroy() {
        this.removeListener();
    }

    // --------------
    // notification -
    // --------------

    accountingItemExportId: string = "";

    onMessage(data) {
        // console.log("on message data", data)
        if (data?.id === this.accountingItemExportId) {
            // const updatedInvoice = data.payload
            // if (this.invoice.status === "BEING_VALIDATED" &&  updatedInvoice.status === "VALIDATED") {
            //     this.invoice.status = updatedInvoice.status
            //     this.invoice.document = updatedInvoice.document
            // }
            if (data.extraPayload?.signedUrl) {
                this.stepData_ = null;
                this.exportLoading = false;
                window.open(data.extraPayload.signedUrl, "_blank");
            }
            // if (data.payload?.signedUrl) {
            //     this.stepData_ = null
            //     this.exportLoading = false
            //     window.open(data.extraPayload.signedUrl, '_blank')
            // }
            else if (data.payload) {
                this.stepData_ = data.payload;
                this.exportLoading = true;
            }
        }
    }

    stepData_ = null;
    downloadLoading: boolean = false;

    get progressStepData() {
        if (this.stepData_) {
            return this.stepData_;
        }
        return {
            action: "",
            step: 0,
            stepCount: 0,
        };
    }

    get progressValue() {
        return (100 * this.progressStepData.step) / this.progressStepData.stepCount;
    }

    cycleTitleRowSpan(index) {
        let amount = 1;
        let i = index + 1;
        while (this.filteredAuditReport?.[i]?.type !== "cycleTitle") {
            amount++;
            i++;
        }
        return amount;
    }

    formatDate(date) {
        return moment(date).format("DD/MM/YYYY");
    }

    getDate(date: string) {
        // return moment(date).format("DD-MM");
        return moment(date).fromNow(true);
    }

    title(control) {
        return dicoTitles[control.title];
    }

    getIconColor(item) {
        if (item.status === "VALIDATED") {
            return "primary";
        }
        return "grey";
    }

    getAuditReviewIcon(item) {
        switch (item.reviewed) {
            case -1:
                return "$fa-thumbs-down";
            case 0:
                return "$oss-circle-uncheck";
            case 1:
                return "$fa-thumbs-up";
        }
    }

    getAuditReviewIconColor(item) {
        switch (item.reviewed) {
            case -1:
                return "red";
            case 0:
                return "grey";
            case 1:
                return "green";
        }
    }

    resetExportDialog() {
        this.exportShortComment = true;
        this.exportFullComment = true;
        this.exportAnnexes = false;
        this.exportWindowStep = 0;
    }

    async updateAuditCheckReview(item, allReviewed: number = undefined) {
        if (!item) {
            debugger;
            return;
        }
        if (item.key && item.auditCheckResultIds?.length) {
            item.reviewed =
                allReviewed !== undefined
                    ? allReviewed
                    : item.reviewed > 0
                      ? -1
                      : item.reviewed + 1;

            const result = await this.$apollo.mutate({
                mutation: UPDATE_AUDIT_CHECK_RESULTS,
                variables: {
                    ids: item.auditCheckResultIds,
                    reviewed: item.reviewed,
                },
            });
            if (result) {
                this.auditReport.find((ar) => ar.key === item.key).reviewed = item.reviewed;
                // await this.createUserActivity(item.auditCheckResultIds[0], item.key, "REVIEW", 1) // deprecated
            }
        }
    }

    async updateAllAuditCheckReview() {
        if (this.auditReport.length) {
            for (const item of this.auditReport) {
                if (item.status === "VALIDATED") {
                    // eslint-disable-next-line no-await-in-loop
                    await this.updateAuditCheckReview(item, 1);
                }
            }
        }
    }

    @Apollo({
        query: AUDIT_REPORT,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                accountingReviewLayoutId: this.accountingReviewLayoutId,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId || !this.accountingReviewLayoutId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.auditReport) {
                    this.categories = [];
                    this.auditReport = data.auditReport.output;
                    this.calculateCycles();
                } else {
                    this.auditReport = [];
                    this.categories = [];
                    this.previousNextFilteredControls = [];
                }
            }
        },
    })
    cycles: Array<any> = [];

    tabCycles: Array<any> = [];

    // auditReport = []
    @State2Way("updateAuditReportAccountingReviewLayout", "auditReport.accountingReviewLayout")
    auditReport: any;

    @Watch("selectedCycleTitle")
    onCyclesChange() {
        this.previousNextFilteredControls = this.getPreviousNextFilteredControls;
    }

    @Apollo({
        query: CANDIDATE_ACCOUNTING_REVIEW_LAYOUTS,
        variables() {
            return {
                companyId: this.companyId,
                isAccountingSituation: this.accountingPeriod?.isAccountingSituationOf
                    ? true
                    : false,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriod?.id;
        },
        result({ data, loading }: any) {
            if (data?.candidateAccountingReviewLayouts?.result?.length) {
                const accountingReviewLayouts = JSON.parse(
                    JSON.stringify(data.candidateAccountingReviewLayouts.result),
                );
                this.candidateAccountingReviewLayouts = accountingReviewLayouts;
                this.accountingReviewLayoutId = accountingReviewLayouts[0].id;

                // if (!this.accountingReviewLayoutId) {
                //     this.accountingReviewLayoutId = accountingReviewLayouts[0].id
                // } else if (!(accountingReviewLayouts.filter(arl => arl.id === this.accountingReviewLayoutId)).length) {
                //     this.accountingReviewLayoutId = accountingReviewLayouts[0].id
                // }
            } else {
                this.candidateAccountingReviewLayouts = [];
            }
        },
    })
    candidateAccountingReviewLayouts: Array<any> = [];

    @Apollo({
        query: DECLARATIONS_LIST,
        skip() {
            return !this.isAutonomousUser;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.declarationsFormList) {
                    const bncDeclarationForm = data.declarationsFormList.filter(
                        (form) => form.cerfaNumber === "2035ASD",
                    );
                    this.bncFormId = bncDeclarationForm[0].id;
                }
            }
        },
    })
    bncFormId: string = "";

    commonFilters(filteredControls) {
        let localFilteredControls = filteredControls;

        if (this.statusFilter === "toValidate") {
            localFilteredControls = localFilteredControls.filter((ar) => ar.status !== "VALIDATED");
        }

        if (this.statusFilter === "validated") {
            localFilteredControls = localFilteredControls.filter((ar) => ar.status === "VALIDATED");
        }

        if (this.statusFilter === "toReview") {
            localFilteredControls = localFilteredControls.filter((ar) => !ar.reviewed); // ** undefined || 0
        }

        if (this.statusFilter === "reviewed") {
            localFilteredControls = localFilteredControls.filter((ar) => ar.reviewed === 1); // ** && not -1
        }

        if (this.statusFilter === "rejected") {
            localFilteredControls = localFilteredControls.filter((ar) => ar.reviewed === -1);
        }

        if (!this.showManuals) {
            localFilteredControls = localFilteredControls.filter(
                (ar) => !ar.pathName || ar.pathName !== "manual-audit",
            );
        }
        return localFilteredControls;
    }

    // ** filteredAuditReport is used in the AuditReport template,
    // ** showing disabled audits, setting them to VALIDATED and reviewed, with "à venir" in the title
    get filteredAuditReport() {
        if (!this.auditReport.length) {
            return [];
        }
        let filteredControls = cloneDeep(this.auditReport);

        // ** set the disabled audits to VALIDATED and reviewed
        for (const auditKey of disabledAuditKeys) {
            const control = filteredControls.find((ar) => ar.key === auditKey);
            if (control) {
                control.status = "VALIDATED";
                control.reviewed = 1;
            }
        }

        if (this.selectedCycleTitle != "Tous") {
            const selectedCycle = this.cycles?.find(
                (c) => c.cycleTitle === this.selectedCycleTitle,
            );

            filteredControls = this.auditReport.filter(
                (ar) =>
                    this.auditReport.indexOf(ar) >= selectedCycle.indexStart &&
                    this.auditReport.indexOf(ar) <= selectedCycle.indexEnd,
            );
        }

        filteredControls = this.commonFilters(filteredControls);

        filteredControls = this.fixControlParams(filteredControls);

        return filteredControls;
    }

    fixControlParams(filteredControls) {
        for (const control of filteredControls) {
            if (control.action?.params) {
                control.action.params.companyId = this.companyId;
                control.action.params.accountingPeriodId = this.accountingPeriodId;
            }
        }
        return filteredControls;
    }

    // ** previousNextFilteredControls is used in the store, to be used in the opened controls, for previous/next buttons,
    // ** without disabled audits
    get getPreviousNextFilteredControls() {
        let previousNextFilteredControls = cloneDeep(this.auditReport);
        if (disabledAuditKeys?.length) {
            for (const auditKey of disabledAuditKeys) {
                const controlIndex = previousNextFilteredControls.findIndex(
                    (ar) => ar.key === auditKey,
                );
                if (controlIndex > -1) {
                    // ** reduce the indexEnd of the cycleTitle
                    let cycleTitleIndex = -1;
                    for (let i = controlIndex; i >= 0; i--) {
                        if (previousNextFilteredControls?.[i]?.type === "cycleTitle") {
                            cycleTitleIndex = i;
                            previousNextFilteredControls[cycleTitleIndex].indexEnd--;
                            break;
                        }
                    }

                    // ** remove the control
                    previousNextFilteredControls.splice(controlIndex, 1);
                }
            }

            if (this.selectedCycleTitle != "Tous") {
                const selectedCycle = previousNextFilteredControls?.find(
                    (c) => c.cycleTitle === this.selectedCycleTitle,
                );

                previousNextFilteredControls = previousNextFilteredControls.filter(
                    (ar) =>
                        previousNextFilteredControls.indexOf(ar) >= selectedCycle.indexStart &&
                        previousNextFilteredControls.indexOf(ar) <= selectedCycle.indexEnd,
                );
            }

            this.commonFilters(previousNextFilteredControls);
        }
        return previousNextFilteredControls;
    }

    //
    //
    //
    getAuditProgress(auditCheck) {
        return auditCheck.doneCount + "/" + auditCheck.count;
    }

    openAudit(auditCheck) {
        if (auditCheck.action) {
            const location: any = {
                name: auditCheck.action.pathName,
            };
            if (auditCheck.action.params) {
                location.params = auditCheck.action.params;
            } else {
                location.params = {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                    acKey: auditCheck.key,
                };
            }

            this.$router.push(location);
            return;
        }
        return auditCheck.pathName ? this.openControl(auditCheck) : this.openAction(auditCheck);
    }

    // ** used with manual & salaryCommons
    // ** needs this.addActionData(report) in getAuditReportData
    openAction(check) {
        if (check?.comments[0]?.pathName) {
            const location: any = {
                name: check.comments[0].pathName,
            };
            if (check?.params) {
                location.params = check.params;
            } else {
                location.params = {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                    acKey: check.key,
                };
            }

            this.$router.push(location);
        }
    }

    // ** all other audits
    openControl(control) {
        if (control.pathName) {
            this.$router.push({
                name: control.pathName,
                params: {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                    acKey: control.key,
                },
            });
        }
    }

    // openAction(check) {
    //     debugger
    //     const location: any = {}
    //     if (check.action && check.action.pathName && check.action.params) {
    //         location.name = check.action.pathName
    //         location.params = check.action.params;
    //     } else {
    //         location.name = "manual-audit",
    //         location.params = {
    //             accountingPeriodId: this.accountingPeriodId,
    //             companyId: this.companyId
    //         }
    //     }
    //     this.$router.push(location);
    // }

    toArray(comment) {
        if (comment) {
            const carriedTexts = comment.split("\n");
            return carriedTexts;
        }
        return [];
    }

    nextStepExportDialog() {
        switch (this.exportWindowStep) {
            case 0:
                this.exportWindowStep++;
                break;
            case 1:
                this.exportWindowStep++;
                break;
            case 2:
                this.exportWindowStep++;
                break;
        }
    }

    exportLoading: boolean = false;

    async exportFile(type) {
        this.exportLoading = true;
        const result = await this.$apollo.mutate({
            mutation: AUDIT_REPORT_TO_DOCX,
            variables: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                docType: type,
                exportShortComment: this.exportShortComment,
                exportFullComment: this.exportFullComment,
                exportAnnexes: this.exportAnnexes,
                accountingReviewLayoutId: this.accountingReviewLayoutId || "default",
            },
        });
        if (result.data?.auditReportToDocx?.accountingItemExportId) {
            this.accountingItemExportId = result.data.auditReportToDocx.accountingItemExportId;
        } else {
            this.accountingItemExportId = "";
        }
        this.exportDialog = false;
    }

    generateBncLiasse() {
        this.$router.push({ name: "declaration-new", params: { formId: this.bncFormId } });
    }

    async generateTaxReturn() {
        await this.$apollo.mutate({
            mutation: GENERATE_TAX_RETURN,
            variables: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                options: this.options,
            },
        });

        this.dialogGenerateLiasse = false;

        this.$router.push({ name: "taxForms" });
    }

    get doneCount_count() {
        let doneCount = 0;
        let count = 0;
        const acceptedStatuses = ["UNKNOWN", "IGNORE", "VALIDATED"];
        for (const audit of this.filteredAuditReport) {
            if (audit.key) {
                // ** not if cycleTitle
                if (
                    acceptedStatuses.includes(audit.status) ||
                    disabledAuditKeys.includes(audit.key)
                ) {
                    doneCount++;
                }
                count++;
            }
        }
        return {
            doneCount: doneCount,
            count: count,
        };
    }

    get globalStatus() {
        const { doneCount, count } = this.doneCount_count;

        return doneCount + "/" + count;
    }

    get globalStatusPercent() {
        const { doneCount, count } = this.doneCount_count;

        return (doneCount / count) * 100;
    }

    getAuditCheckProgress(auditCheckResult) {
        const acceptedStatuses = ["UNKNOWN", "IGNORE", "VALIDATED"];
        if (
            acceptedStatuses.includes(auditCheckResult.status) ||
            disabledAuditKeys.includes(auditCheckResult.key)
        ) {
            return 100;
        }
        return (auditCheckResult.doneCount / auditCheckResult.count) * 100;
    }

    calculateCycles() {
        if (!this.auditReport?.length) {
            this.cycles = [];
        } else {
            let cycleIndex: number = undefined;

            const allAuditReportAccountableAccounts = [];

            if (!this.auditReport[0].cycleTitle) {
                let indexEnd = this.auditReport.length - 1;
                const nextCycleTitleIndex = this.auditReport.findIndex((ar) => ar.cycleTitle);
                if (nextCycleTitleIndex !== -1) {
                    indexEnd = nextCycleTitleIndex;
                }

                this.auditReport.unshift({
                    type: "cycleTitle",
                    cycleTitle: "Sans titre",
                    indexStart: 0,
                    indexEnd: indexEnd,
                });
            }

            let aas = [];
            let excludedAas = [];
            for (let i = 0; i < this.auditReport.length; i++) {
                if (this.auditReport[i].cycleTitle) {
                    cycleIndex = i;
                } else {
                    // ** fill aas to add  them to the aas array
                    if (this.auditReport[i]?.auditReportAccountableAccounts?.length) {
                        aas.push(...this.auditReport[i].auditReportAccountableAccounts);
                    } else {
                        // ** auditReportAccountableAccounts may be empty

                        if (!this.auditReport[i]?.auditReportAccountableAccounts) {
                            console.error(
                                "🚀 - calculateCycles - this.auditReport[i] without auditReportAccountableAccounts:",
                                this.auditReport[i],
                            );
                        }
                    }
                    if (this.auditReport[i].auditReportExcludedAccountableAccounts?.length) {
                        excludedAas.push(
                            ...this.auditReport[i].auditReportExcludedAccountableAccounts,
                        );
                    }
                }

                if (i === this.auditReport.length - 1 || this.auditReport[i + 1].cycleTitle) {
                    this.auditReport[cycleIndex].accountableAccountsRoot =
                        this.removeDoubleAccountableAccountRoots(aas) || [];
                    this.auditReport[cycleIndex].excludedAccountableAccountsRoot =
                        this.removeDoubleAccountableAccountRoots(excludedAas) || [];

                    allAuditReportAccountableAccounts.push(...aas);

                    aas = [];
                    excludedAas = [];
                }
            }

            const uniquesAllAuditReportAccountableAccounts =
                this.removeDoubleAccountableAccountRoots(allAuditReportAccountableAccounts);

            const missingRoots2 = [];

            for (let firstDigit = 1; firstDigit <= 7; firstDigit++) {
                const classRoots = uniquesAllAuditReportAccountableAccounts.filter((num) =>
                    String(num).startsWith(String(firstDigit)),
                );

                if (classRoots.includes(String(firstDigit))) continue;

                this.findMissingRoots(classRoots, String(firstDigit), 2, missingRoots2);
            }

            const orphelinsAudit = this.auditReport.find(
                (ar) => ar.cycleTitle === "J - Autres comptes",
            );
            if (orphelinsAudit) {
                orphelinsAudit.accountableAccountsRoot = missingRoots2;
            }

            const cycles = this.auditReport?.filter((ar) => ar.cycleTitle) || [];

            // ** set the indexStart and indexEnd of each cycle controls
            for (let ci = 0; ci < cycles.length; ci++) {
                // ** first control have indexStart = title index + 1
                cycles[ci].indexStart = this.auditReport.indexOf(cycles[ci]);
                if (!this.auditReport[cycles[ci].indexStart + 1]?.cycleTitle) {
                    // ** if there is a next cycle, indexEnd = next cycle index - 1
                    if (cycles[ci + 1]) {
                        cycles[ci].indexEnd = this.auditReport.indexOf(cycles[ci + 1]) - 1;
                    } else {
                        // ** if there is no next cycle, indexEnd = last control index
                        cycles[ci].indexEnd = this.auditReport.length - 1;
                    }
                } else {
                    // ** if there is no control after the cycle title, indexStart + indexEnd = null
                    cycles[ci].indexStart = null;
                    cycles[ci].indexEnd = null;
                }
            }

            this.tabCycles = JSON.parse(JSON.stringify(cycles));

            // ** if no selectedCycleGLTab, select the first one
            // ** mandatory for roots + generalLedger
            if (this.selectedCycleGLTab === null) {
                this.selectedCycleGLTab = this.tabCycles[0];
            }

            cycles.unshift({
                cycleTitle: "Tous",
                indexStart: 0,
                indexEnd: this.auditReport.length - 1,
            });
            this.cycles = cycles;

            this.previousNextFilteredControls = this.getPreviousNextFilteredControls;
        }
    }

    get templateAccountableAccountRoots() {
        if (this.selectedCycleGLTab?.accountableAccountsRoot?.length) {
            let aas: Array<string> = this.removeDoubleAccountableAccountRoots(
                this.selectedCycleGLTab.accountableAccountsRoot,
            );
            return aas.join("  ");
        }
        return "Aucune";
    }

    get templateExcludedAccountableAccountRoots() {
        if (this.selectedCycleGLTab?.excludedAccountableAccountsRoot?.length) {
            let aas: Array<string> = this.removeDoubleAccountableAccountRoots(
                this.selectedCycleGLTab.excludedAccountableAccountsRoot,
            );
            return aas.join("  ");
        }
        return null;
    }

    removeDoubleAccountableAccountRoots(fullAaRoots) {
        let filteredAaRoots = [];
        if (fullAaRoots.length) {
            if (fullAaRoots.length === 1) {
                filteredAaRoots = fullAaRoots;
            } else {
                // ** remove duplicates and sort
                filteredAaRoots = [...new Set(fullAaRoots)];

                if (filteredAaRoots.length > 1) {
                    filteredAaRoots.sort();

                    // ** ex.: remove 512 if 51 is present
                    filteredAaRoots = filteredAaRoots.filter((item) => {
                        return !filteredAaRoots.some(
                            (otherItem) => otherItem !== item && item.startsWith(otherItem),
                        );
                    });
                }
            }
        }
        return filteredAaRoots;
    }

    // async createUserActivity(auditCheckResultId, auditCheckKey, action: string, manualDuration = null) { // deprecated
    //     if (!action) {
    //         action = auditCheckResultId ? "UPDATE" : "CREATE"
    //     }
    //     try {
    //         console.log("activity action", action)
    //         await this.activity.create(this.$apollo, this.currentUser.id, this.companyId, auditCheckKey, action, this.accountingPeriodId, manualDuration)
    //         this.initializeUserActivity()
    //     } catch(e) {
    //         console.error(e)
    //     }
    // }

    findMissingRoots(classRoots, prefix = "", depth = 1, missingRoots2 = []) {
        // First digit is from 1 to 7, followings from 0 to 9
        const startDigit = depth === 1 ? 1 : 0;
        const endDigit = depth === 1 ? 7 : 9;

        if (depth > 4) return;

        for (let digit = startDigit; digit <= endDigit; digit++) {
            const currentRoot = "" + prefix + digit;

            if (classRoots.includes(currentRoot)) continue;

            const nextClassRoots = classRoots.filter((cr) => cr.startsWith(currentRoot));

            if (nextClassRoots.length) {
                this.findMissingRoots(nextClassRoots, currentRoot, depth + 1, missingRoots2);
            } else {
                missingRoots2.push(currentRoot);
            }
        }
    }

    getDisplayedTitle(title, isHovering) {
        if (isHovering) {
            // Shows 35 characters if isHovering
            return title.length > 35 ? title.substring(0, 35) + "..." : title;
        } else {
            // Shows 7 characters if not isHovering
            return title.length > 7 ? title.substring(0, 7) + "..." : title;
        }
    }
}

export default toNative(AuditReport);
</script>
